// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__W7noM","header":"MergedInvoice_header__2k7KC"};